import { lazy } from 'react';

/**
 * shikiの本体と文法は、コードタブを開かない画面では要らない。
 * BpmnViewerLazyと同じく、遅延読み込みの入口をここに1つ置く。
 */
export const CodeViewerLazy = lazy(async () => {
  const module = await import('./CodeViewer');
  return { default: module.CodeViewer };
});

export type { CodeViewerProps } from './CodeViewer';
